import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { inject } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { normalizeCurrency } from 'beebee-base/lib/utility';
import { _saveAll, _safeReload, applyStyle, _sortedCustomFields } from '../lib/utility.js';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81;
let ExpenseModel = (_dec = attr('boolean'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec0 = attr('number'), _dec1 = attr('string'), _dec10 = attr('number'), _dec11 = attr('boolean'), _dec12 = attr('string'), _dec13 = attr('number', {
  currency: true
}), _dec14 = attr('number', {
  currency: true
}), _dec15 = attr('boolean'), _dec16 = attr('string'), _dec17 = attr('number', {
  currency: true
}), _dec18 = attr('boolean', {
  defaultValue: true
}), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('boolean'), _dec22 = attr('string'), _dec23 = attr('string'), _dec24 = attr('string'), _dec25 = attr('string'), _dec26 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec27 = attr('boolean'), _dec28 = attr('string'), _dec29 = attr('string'), _dec30 = attr('string'), _dec31 = belongsTo('address', {
  inverse: null,
  async: false
}), _dec32 = attr('string'), _dec33 = attr('string'), _dec34 = attr('string'), _dec35 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec36 = attr('boolean'), _dec37 = attr('string'), _dec38 = belongsTo('address', {
  inverse: null,
  async: false
}), _dec39 = attr('string'), _dec40 = attr('string'), _dec41 = attr('string'), _dec42 = attr('string'), _dec43 = attr('string', {
  defaultValue: 'EUR'
}), _dec44 = attr('number'), _dec45 = attr('number', {
  currency: true
}), _dec46 = attr('number', {
  currency: true
}), _dec47 = attr('boolean', {
  defaultValue: false
}), _dec48 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec49 = hasMany('product', {
  inverse: null,
  async: false
}), _dec50 = hasMany('project', {
  inverse: null,
  async: false
}), _dec51 = hasMany('event', {
  inverse: null,
  async: false
}), _dec52 = hasMany('workhour', {
  inverse: null,
  async: false
}), _dec53 = hasMany('invoice', {
  inverse: null,
  async: false
}), _dec54 = hasMany('expense', {
  inverse: null,
  async: false
}), _dec55 = hasMany('expensearticle', {
  inverse: 'expense',
  async: false
}), _dec56 = attr('string'), _dec57 = attr('string'), _dec58 = attr('string'), _dec59 = attr('string'), _dec60 = hasMany('file', {
  inverse: null,
  async: true
}), _dec61 = hasMany('payment', {
  inverse: null,
  async: false
}), _dec62 = hasMany('invoicetax', {
  inverse: 'expense',
  async: false
}), _dec63 = hasMany('expire_date', {
  inverse: 'expense',
  async: false
}), _dec64 = hasMany('custom_field', {
  inverse: null,
  async: false
}), _dec65 = attr('string'), _dec66 = attr('string'), _dec67 = attr('string'), _dec68 = attr('string'), _dec69 = attr('number', {
  defaultValue: 0
}), _dec70 = attr('number', {
  defaultValue: 0
}), _dec71 = attr('number', {
  defaultValue: 0
}), _dec72 = attr('number', {
  defaultValue: 0
}), _dec73 = attr('number', {
  defaultValue: 0
}), _dec74 = attr('number', {
  defaultValue: 0
}), _dec75 = attr('number', {
  defaultValue: 0
}), _dec76 = attr('number', {
  defaultValue: 0
}), _dec77 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec78 = attr('boolean', {
  defaultValue: false
}), _class = class ExpenseModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "checked", _descriptor3, this);
    _initializerDefineProperty(this, "archivied", _descriptor4, this);
    _initializerDefineProperty(this, "created_at", _descriptor5, this);
    _initializerDefineProperty(this, "date", _descriptor6, this);
    _initializerDefineProperty(this, "ref_number", _descriptor7, this);
    _initializerDefineProperty(this, "status", _descriptor8, this);
    _initializerDefineProperty(this, "status_sdi", _descriptor9, this);
    _initializerDefineProperty(this, "has_ritenuta", _descriptor0, this);
    _initializerDefineProperty(this, "has_autofattura", _descriptor1, this);
    _initializerDefineProperty(this, "recursive", _descriptor10, this);
    _initializerDefineProperty(this, "recursive_period", _descriptor11, this);
    _initializerDefineProperty(this, "recursive_human", _descriptor12, this);
    _initializerDefineProperty(this, "first_rate", _descriptor13, this);
    _initializerDefineProperty(this, "first_rate_included", _descriptor14, this);
    _initializerDefineProperty(this, "description", _descriptor15, this);
    _initializerDefineProperty(this, "imponibile", _descriptor16, this);
    _initializerDefineProperty(this, "total", _descriptor17, this);
    _initializerDefineProperty(this, "is_paid", _descriptor18, this);
    _initializerDefineProperty(this, "paid_date", _descriptor19, this);
    _initializerDefineProperty(this, "fourth_rate", _descriptor20, this);
    _initializerDefineProperty(this, "lordo", _descriptor21, this);
    _initializerDefineProperty(this, "causale", _descriptor22, this);
    _initializerDefineProperty(this, "notes", _descriptor23, this);
    _initializerDefineProperty(this, "is_creditnote", _descriptor24, this);
    _initializerDefineProperty(this, "creditnote_expesenumber", _descriptor25, this);
    _initializerDefineProperty(this, "creditnote_expesedate", _descriptor26, this);
    _initializerDefineProperty(this, "expensecategory", _descriptor27, this);
    _initializerDefineProperty(this, "expensecategory_name", _descriptor28, this);
    _initializerDefineProperty(this, "society", _descriptor29, this);
    _initializerDefineProperty(this, "fisica_giuridica", _descriptor30, this);
    _initializerDefineProperty(this, "society_name", _descriptor31, this);
    _initializerDefineProperty(this, "society_first_name", _descriptor32, this);
    _initializerDefineProperty(this, "society_last_name", _descriptor33, this);
    _initializerDefineProperty(this, "society_address", _descriptor34, this);
    _initializerDefineProperty(this, "society_piva_name", _descriptor35, this);
    _initializerDefineProperty(this, "society_piva", _descriptor36, this);
    _initializerDefineProperty(this, "society_cf", _descriptor37, this);
    _initializerDefineProperty(this, "contact", _descriptor38, this);
    _initializerDefineProperty(this, "contact_fisica_giuridica", _descriptor39, this);
    _initializerDefineProperty(this, "contact_name", _descriptor40, this);
    _initializerDefineProperty(this, "contact_address", _descriptor41, this);
    _initializerDefineProperty(this, "contact_piva", _descriptor42, this);
    _initializerDefineProperty(this, "contact_cf", _descriptor43, this);
    _initializerDefineProperty(this, "contact_first_name", _descriptor44, this);
    _initializerDefineProperty(this, "contact_last_name", _descriptor45, this);
    _initializerDefineProperty(this, "valuta", _descriptor46, this);
    _initializerDefineProperty(this, "tasso_cambio", _descriptor47, this);
    _initializerDefineProperty(this, "discount", _descriptor48, this);
    _initializerDefineProperty(this, "discount_rate", _descriptor49, this);
    _initializerDefineProperty(this, "discount_type", _descriptor50, this);
    _initializerDefineProperty(this, "contacts", _descriptor51, this);
    _initializerDefineProperty(this, "products", _descriptor52, this);
    _initializerDefineProperty(this, "projects", _descriptor53, this);
    _initializerDefineProperty(this, "events", _descriptor54, this);
    _initializerDefineProperty(this, "workhours", _descriptor55, this);
    _initializerDefineProperty(this, "invoices", _descriptor56, this);
    _initializerDefineProperty(this, "related_expenses", _descriptor57, this);
    _initializerDefineProperty(this, "expensearticles", _descriptor58, this);
    _initializerDefineProperty(this, "thumbnail_url", _descriptor59, this);
    _initializerDefineProperty(this, "thumbnail_name", _descriptor60, this);
    _initializerDefineProperty(this, "thumbnail_etag", _descriptor61, this);
    _initializerDefineProperty(this, "thumbnail_type", _descriptor62, this);
    _initializerDefineProperty(this, "files", _descriptor63, this);
    _initializerDefineProperty(this, "payments", _descriptor64, this);
    _initializerDefineProperty(this, "invoicetaxes", _descriptor65, this);
    _initializerDefineProperty(this, "expire_dates", _descriptor66, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor67, this);
    _initializerDefineProperty(this, "esigibilita_iva", _descriptor68, this);
    _initializerDefineProperty(this, "bank_name", _descriptor69, this);
    _initializerDefineProperty(this, "bank_iban", _descriptor70, this);
    _initializerDefineProperty(this, "bank_bic", _descriptor71, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor72, this);
    _initializerDefineProperty(this, "total_payments", _descriptor73, this);
    _initializerDefineProperty(this, "total_payments_number", _descriptor74, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor75, this);
    _initializerDefineProperty(this, "total_products_number", _descriptor76, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor77, this);
    _initializerDefineProperty(this, "total_events_number", _descriptor78, this);
    _initializerDefineProperty(this, "total_related_expenses_number", _descriptor79, this);
    _initializerDefineProperty(this, "current_users", _descriptor80, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor81, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    return _saveAll(model, this.session, 'expenses_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get society_label() {
    const styleName = this.session.option_field?.model_custom_style?.contact;
    if (this.fisica_giuridica) {
      return applyStyle(this.society_name, styleName);
    } else {
      const firstName = this.society_first_name ?? '';
      const lastName = this.society_last_name ?? '';
      const fullName = `${lastName} ${firstName}`.trim();
      return applyStyle(fullName, styleName);
    }
  }
  get contact_label() {
    const styleName = this.session.option_field?.model_custom_style?.contact;
    if (this.contact_fisica_giuridica) {
      return applyStyle(this.contact_name, styleName);
    } else {
      const firstName = this.contact_first_name ?? '';
      const lastName = this.contact_last_name ?? '';
      const fullName = `${lastName} ${firstName}`.trim();
      return applyStyle(fullName, styleName);
    }
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get label() {
    const timeZone = this.session?.me?.time_zone || 'Europe/Rome';
    const start_date = this.date ? this.intl.formatDate(this.date, {
      timeZone
    }) : '';
    return this.date ? `#${this.ref_number ?? ''} ${start_date}` : '';
  }
  get sub_label() {
    const number = this.total ?? 0;
    const currency = this.valuta ?? this.session?.option_field?.intl?.currency ?? 'EUR';
    const tot_currency = this.intl.formatNumber(number, {
      style: 'currency',
      currency: normalizeCurrency(currency)
    });
    return `${tot_currency} ${this.intl.t(`expenses ${this.status}`)} ${this.contact_label ?? ''}`;
  }
  get payment_due() {
    return (this.total ?? 0) - (this.total_payments ?? 0);
  }
  get current_users_label() {
    return this.current_users.map(user => user.label).join(' ');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "date", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "ref_number", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "status_sdi", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "has_ritenuta", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "has_autofattura", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "recursive", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "recursive_period", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "recursive_human", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "first_rate", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "first_rate_included", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "imponibile", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "is_paid", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "paid_date", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "fourth_rate", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "lordo", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "causale", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "is_creditnote", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "creditnote_expesenumber", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "creditnote_expesedate", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "expensecategory", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "expensecategory_name", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "society", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "fisica_giuridica", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "society_name", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "society_first_name", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "society_last_name", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "society_address", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "society_piva_name", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "society_piva", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "society_cf", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "contact_fisica_giuridica", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "contact_name", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "contact_address", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "contact_piva", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "contact_cf", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "contact_first_name", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "contact_last_name", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "valuta", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "tasso_cambio", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "discount", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "discount_rate", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "discount_type", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "events", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "workhours", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "invoices", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "related_expenses", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "expensearticles", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_url", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_name", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_etag", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_type", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "payments", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "invoicetaxes", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "expire_dates", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "esigibilita_iva", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "bank_name", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "bank_iban", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "bank_bic", [_dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "total_payments", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "total_payments_number", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "total_products_number", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "total_events_number", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "total_related_expenses_number", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ExpenseModel as default };
//# sourceMappingURL=expense.js.map
